module.exports = __webpack_public_path__ + "img/mezzo1.3a0b56e1.png";